import React, { PropsWithChildren } from 'react';

export function PagePublicationInfoButtons(props: PropsWithChildren) {
  return <div className="page-publication-info__buttons">{props.children}</div>;
}
